import { _ep0, _mw0, command } from "../commandBuilder";
import { UpdateBaptism$ } from "../schemas/schemas_0";
export class UpdateBaptismCommand extends command(_ep0, _mw0, "UpdateBaptism", UpdateBaptism$) {
}
